import type { BffApiClient } from "@/app/api-client"
import type { InferRequestType } from "hono"

export type QueryInput = InferRequestType<
  BffApiClient["api"]["collections"][":id"]["statistic"]["$get"]
>["param"]

export const getCollectionStatisticQueryParams = (
  apiClient: BffApiClient,
  queryInput: QueryInput,
) => {
  return {
    queryKey: ["collections", "statistic", queryInput],
    queryFn: async () => {
      const response = await apiClient.api.collections[":id"].statistic.$get({
        param: queryInput,
      })

      if (!response.ok) throw await response.json()

      return response.json()
    },
  }
}

type QueryFn = ReturnType<typeof getCollectionStatisticQueryParams>["queryFn"]

export type QueryResponse = Awaited<ReturnType<QueryFn>>
